import React from 'react'
import { XMarkIcon } from '@heroicons/react/20/solid'

export type FilterChipTone = 'neutral' | 'muted' | 'accent'

const toneClasses: Record<FilterChipTone, { chip: string; icon: string }> = {
  neutral: {
    chip: 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50',
    icon: 'text-gray-400',
  },
  muted: {
    chip: 'border-gray-200 bg-gray-50 text-gray-700 hover:bg-gray-100',
    icon: 'text-gray-500',
  },
  accent: {
    chip: 'border-perfect-shine-200 bg-perfect-shine-50 text-perfect-shine-700 hover:bg-perfect-shine-100',
    icon: 'text-perfect-shine-500',
  },
}

interface FilterChipProps {
  label: React.ReactNode
  onRemove: () => void
  tone?: FilterChipTone
  'data-testid'?: string
}

// A removable pill used in the marketplace toolbars (carbon + ppa). Renders a
// label with a trailing dismiss icon; `tone` selects the shared visual variant.
const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove, tone = 'neutral', 'data-testid': testId }) => {
  const t = toneClasses[tone]
  return (
    <button
      type="button"
      onClick={onRemove}
      data-testid={testId}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-1 text-[11px] font-medium shadow-xs ${t.chip}`}
    >
      {label}
      <XMarkIcon className={`h-3 w-3 ${t.icon}`} aria-hidden="true" />
    </button>
  )
}

export default FilterChip
